var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledSystem = require("@sport1/styled-system");

var _sport1EventListeners = require("@sport1/sport1-event-listeners");

var _Basic = require("../../../elements/Basic");

var _Logos = require("../Basic/Logos");

var _Touchable = _interopRequireDefault(require("../Basic/Touchable"));

var _jsxFileName = "/builds/sport1/libraries/universal-components/lib/components/Universal/Betting/index.js";

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function _createSuperInternal() {
    var Super = (0, _getPrototypeOf2.default)(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = (0, _getPrototypeOf2.default)(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return (0, _possibleConstructorReturn2.default)(this, result);
  };
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

var Betting = function (_React$Component) {
  (0, _inherits2.default)(Betting, _React$Component);

  var _super = _createSuper(Betting);

  function Betting() {
    var _this;

    (0, _classCallCheck2.default)(this, Betting);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _this.componentWillUnmount = function () {
      _sport1EventListeners.EventRegister.removeEventListener(_this.listener);
    };

    return _this;
  }

  (0, _createClass2.default)(Betting, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var trackData = {
        type: 'BET_QUOTES_IMPRESSION',
        competition: this.props.competition
      };

      if (this.props.pageId) {
        this.listener = _sport1EventListeners.EventRegister.addEventListener("reloadBettingViews_" + this.props.pageId, function () {
          _sport1EventListeners.EventRegister.emit('trackBettingView', trackData);
        });
      }

      if (typeof this.props.trackBwin === 'function') {
        this.props.trackBwin(trackData);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          providerLogo = _this$props.providerLogo,
          _this$props$providerL = _this$props.providerLogoStyles,
          providerLogoStyles = _this$props$providerL === void 0 ? {} : _this$props$providerL,
          logoLink = _this$props.logoLink,
          quotes = _this$props.quotes,
          moduleStyles = _this$props.moduleStyles,
          oddsStyle = _this$props.oddsStyle,
          competition = _this$props.competition,
          trackBwin = _this$props.trackBwin,
          _onPress = _this$props.onPress,
          wStyles = _this$props.wStyles,
          rest = (0, _objectWithoutProperties2.default)(_this$props, ["providerLogo", "providerLogoStyles", "logoLink", "quotes", "moduleStyles", "oddsStyle", "competition", "trackBwin", "onPress", "wStyles"]);
      if (!quotes.length) return null;
      var logoWidth = providerLogoStyles.width,
          logoHeight = providerLogoStyles.height,
          logoContainerStyles = providerLogoStyles.containerStyles;
      var oddsTextStyle = oddsStyle.oddsTextStyle,
          oddsNameTextStyle = oddsStyle.oddsNameTextStyle,
          oddsBackgroundColor = oddsStyle.oddsBackgroundColor;
      return _react.default.createElement(_Basic.Row, (0, _extends2.default)({
        mx: 2,
        evenly: true
      }, rest, {
        __source: {
          fileName: _jsxFileName,
          lineNumber: 84,
          columnNumber: 13
        }
      }), _react.default.createElement(_Basic.Column, {
        center: true,
        mx: 2,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 85,
          columnNumber: 17
        }
      }, _react.default.createElement(_Basic.Text, (0, _extends2.default)({}, wStyles, {
        __source: {
          fileName: _jsxFileName,
          lineNumber: 86,
          columnNumber: 21
        }
      }), "-w-")), quotes.map(function (quote) {
        return _react.default.createElement(_Touchable.default, (0, _extends2.default)({
          key: "quote_" + quote.link,
          column: true,
          mx: 2,
          flexing: true,
          position: "relative",
          center: true,
          bg: oddsBackgroundColor || 'background.secondary',
          hover: {
            backgroundColor: '#ccc'
          },
          height: 24,
          target: "_blank",
          href: quote.link,
          rel: "nofollow",
          onPress: function onPress() {
            if (typeof trackBwin === 'function') {
              trackBwin({
                type: 'BET_QUOTES_AD_CLICK',
                competition: competition,
                link: quote.link
              });
            }

            if (_onPress && typeof _onPress === 'function') {
              _onPress();
            }
          }
        }, moduleStyles, {
          __source: {
            fileName: _jsxFileName,
            lineNumber: 89,
            columnNumber: 21
          }
        }), _react.default.createElement(_Basic.Row, {
          isFlex: true,
          center: true,
          width: "100%",
          __source: {
            fileName: _jsxFileName,
            lineNumber: 116,
            columnNumber: 25
          }
        }, _react.default.createElement(_Basic.Text, (0, _extends2.default)({
          mr: 3,
          size: "custom",
          fontSize: (0, _styledSystem.themeGet)('fontSizes.0', 8)(_this2.props)
        }, oddsNameTextStyle, {
          __source: {
            fileName: _jsxFileName,
            lineNumber: 117,
            columnNumber: 29
          }
        }), quote.info), _react.default.createElement(_Basic.Text, (0, _extends2.default)({
          size: "custom",
          fontSize: (0, _styledSystem.themeGet)('fontSizes.1', 13)(_this2.props)
        }, oddsTextStyle, {
          __source: {
            fileName: _jsxFileName,
            lineNumber: 125,
            columnNumber: 29
          }
        }), quote.odds)));
      }), _react.default.createElement(_Touchable.default, (0, _extends2.default)({
        column: true,
        mx: 2,
        center: true,
        p: 2,
        bg: "white",
        target: "_blank",
        href: logoLink,
        rel: "nofollow",
        onPress: function onPress() {
          if (typeof trackBwin === 'function') {
            trackBwin({
              type: 'BET_QUOTES_AD_CLICK',
              competition: competition,
              link: logoLink
            });
          }

          if (_onPress && typeof _onPress === 'function') {
            _onPress();
          }
        }
      }, logoContainerStyles, {
        __source: {
          fileName: _jsxFileName,
          lineNumber: 135,
          columnNumber: 17
        }
      }), _react.default.createElement(_Logos.AssetLogo, {
        width: logoWidth || 24,
        height: logoHeight || 8,
        center: true,
        src: providerLogo,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 158,
          columnNumber: 21
        }
      })));
    }
  }]);
  return Betting;
}(_react.default.Component);

Betting.propTypes = {
  competition: _propTypes.default.object,
  providerLogo: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.object]),
  providerLogoStyles: _propTypes.default.object,
  moduleStyles: _propTypes.default.object,
  oddsStyle: _propTypes.default.object,
  wStyles: _propTypes.default.object,
  quotes: _propTypes.default.arrayOf(Object).isRequired,
  trackBwin: _propTypes.default.func,
  onPress: _propTypes.default.func,
  pageId: _propTypes.default.string,
  logoLink: _propTypes.default.string
};
Betting.defaultProps = {
  oddsStyle: {
    oddsTextStyle: {},
    oddsNameTextStyle: {},
    oddsBackgroundColor: undefined,
    wStyles: {}
  }
};
var _default = Betting;
exports.default = _default;